import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ListsIcon, LockedIcon } from 'foundations-assets';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import InviteSeatsContext from 'growth-invite-components/contexts/InviteSeatsContext';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { useIsPaidPortal } from 'onboarding-scopes';
import { useUserManagementUpgradeKey } from 'setup-guide-components/hooks/upgradeKey';
import { useInviteYourTeamTaskIdFromList } from '../../hooks/task';
import { trackSectionView, trackUserInteraction } from '../../utils/usageTracker';
import { getUserManagementNewUserFlowLink } from '../../utils/urls';
import { QUICK_INVITE_MODAL_PATH } from 'setup-guide-components/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const SetupGuideNavFreeInviteLinkItem = () => {
  const history = useHistory();
  const inviteSeats = useContext(InviteSeatsContext);
  const {
    hasInviteSeats,
    isLoading
  } = inviteSeats || {};
  const userManagementUpgradeKey = useUserManagementUpgradeKey();
  const {
    openUpgradeModal
  } = useUpgradeModal(userManagementUpgradeKey);
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(SideNavItem, {
    "data-test-id": "side-nav-invite-link",
    iconLeft: /*#__PURE__*/_jsx(IconHolder, {
      icon: ListsIcon,
      paddingBlock: "0",
      paddingBlockStart: "50",
      paddingInline: "0",
      size: "400"
    }),
    iconRight: hasInviteSeats ? /*#__PURE__*/_jsx(HelpIcon, {
      color: "icon-secondary-disabled",
      paddingBlockStart: "50",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.tabs.inviteLink.tooltipText"
      }),
      tooltipPlacement: "right",
      tooltipProps: {
        onOpenChange: evt => {
          if (evt.currentTarget.value) {
            trackSectionView('side nav invite link tooltip');
          }
        },
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.tabs.inviteLink.tooltipTitle"
        }),
        use: 'longform'
      }
    }) : /*#__PURE__*/_jsx(LockedIcon, {}),
    onClick: () => {
      trackUserInteraction('click side nav invite link');
      if (!hasInviteSeats) {
        openUpgradeModal();
      } else {
        history.push(`${QUICK_INVITE_MODAL_PATH}?quickInviteModalTitle=invite-your-team`);
      }
    },
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.tabs.inviteLink.text"
    })
  });
};
const SetupGuideNavPaidInviteLinkItem = () => {
  const {
    taskId: inviteYourTeamTaskId,
    isLoading: isLoadingTaskData
  } = useInviteYourTeamTaskIdFromList();
  if (isLoadingTaskData) {
    return null;
  }
  return /*#__PURE__*/_jsx(SideNavItem, {
    "data-test-id": "side-nav-invite-link",
    href: getUserManagementNewUserFlowLink(inviteYourTeamTaskId),
    iconLeft: /*#__PURE__*/_jsx(IconHolder, {
      icon: ListsIcon,
      paddingBlock: "0",
      paddingBlockStart: "50",
      paddingInline: "0",
      size: "400"
    }),
    iconRight: /*#__PURE__*/_jsx(HelpIcon, {
      color: "icon-secondary-disabled",
      paddingBlockStart: "50",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.tabs.inviteLink.tooltipText"
      }),
      tooltipPlacement: "right",
      tooltipProps: {
        onOpenChange: evt => {
          if (evt.currentTarget.value) {
            trackSectionView('side nav invite link tooltip');
          }
        },
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.tabs.inviteLink.tooltipTitle"
        }),
        use: 'longform'
      }
    }),
    onClick: () => {
      trackUserInteraction('click side nav invite link');
    },
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.tabs.inviteLink.text"
    })
  });
};
const SetupGuideNavInviteLinkItem = ({
  showInviteLink
}) => {
  const isPaidPortal = useIsPaidPortal();
  if (!showInviteLink) {
    return null;
  }

  // If Free Portal, it opens up Quick Invite
  // If Paid Portal, it launches the User Management Flow
  if (isPaidPortal) {
    return /*#__PURE__*/_jsx(SetupGuideNavPaidInviteLinkItem, {});
  }
  return /*#__PURE__*/_jsx(SetupGuideNavFreeInviteLinkItem, {});
};
export default SetupGuideNavInviteLinkItem;